import React, { useEffect } from "react";
import styles from "./ProductCategoryPage.module.css";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useProductStore from "../../Stores/useProductStore";
import NewPolaroid from "../../Components/Products/NewPolaroid";
import BreadCrumb from "../../Components/Products/BreadCrumb/BreadCrumb";
import SpecificProduct from "../../Components/Products/SpecificProduct/SpecificProduct";
import CategorySelector from "../../Components/Products/CategorySelection/CategorySelector";
import useCategoryStore from "../../Stores/useCategoryStore";

function ProductCategoryPage() {
  const { CategoryProduct, Product } = useParams();
  const location = useLocation();
  const isWholesaleRoute = location.pathname.startsWith("/Wholesale/Products");
  const baseRoute = isWholesaleRoute ? "/Wholesale/Products" : "/Products";
  const routeProp = isWholesaleRoute ? "Wholesale/Products" : "Products";
  const {
    getProductsByCategoryOrFriendlyName,
    categoriesList,
    product,
    getProductByCategoryAndFriendlyName,
    IsCategory,
    IsProduct,
  } = useProductStore();

  // const [selectedCategory, setSelectedCategory] = React.useState(null);

  const { selectedCategory, setSelectedCategory, categories } =
    useCategoryStore();

  const findCategoryByFriendlyName = (friendlyName) => {
    return categories.find((cat) => cat.FriendlyName === friendlyName);
  };

  useEffect(() => {
    console.log("Params changed: ", CategoryProduct, Product);
    if (CategoryProduct && Product) {
      getProductByCategoryAndFriendlyName(CategoryProduct, Product);
    }
    if (CategoryProduct && !Product) {
      console.log("Fetching products for category: ", CategoryProduct);

      getProductsByCategoryOrFriendlyName(CategoryProduct);
    }

    const category = findCategoryByFriendlyName(CategoryProduct);
    setSelectedCategory(category);
  }, [
    CategoryProduct,
    Product,
    getProductByCategoryAndFriendlyName,
    getProductsByCategoryOrFriendlyName,
    categories
  ]);

  const categoryData = categoriesList.find(
    (cat) =>
      cat.CategoryName === (selectedCategory?.FriendlyName || CategoryProduct)
  );

  const productsToShow = IsCategory ? categoryData?.Items || [] : [];

  const handleCatName = async (name) => {
    console.log("Category name from selector: ", name);
    setSelectedCategory(name);
    if (name == null) {
      // setCategoryName("");
      getProductsByCategoryOrFriendlyName(CategoryProduct);
    } else {
      // setCategoryName(name.FriendlyName);
      getProductsByCategoryOrFriendlyName(name.FriendlyName);
    }

    if (name == null) {
      window.history.replaceState(null, "", baseRoute);

      return;
    }

    window.history.replaceState(null, "", `${baseRoute}/${name.FriendlyName}`);
  };

  return (
    <div>      
      {IsCategory ? (
        <div className={styles.ProductsPage}>
          <CategorySelector
            categorySelected={handleCatName}
            selectedCategory={selectedCategory}
          />
          <div className={styles.selectedCategory}>
                  {selectedCategory && selectedCategory?.Value ? selectedCategory.Value : "All Products"}
                </div>
          <div className={styles.Wrapper}>
            {productsToShow.length > 0
              ? productsToShow.map((product, index) => (
                  <NewPolaroid
                    key={index}
                    Name={product.Name}
                    Price={product.Price}
                    FriendlyName={product.FriendlyName}
                    Images={product.Images}
                    Route={routeProp}
                  />
                ))
              : "No products found in this category."}
          </div>
        </div>
      ) : (
        <div className={styles.IsProduct}>
          <SpecificProduct />
        </div>
      )}
    </div>
  );
}

export default ProductCategoryPage;
